import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { serviceApi } from '~/features';
import { ReportsBannerDto } from '~/types';

export const DOWNLOAD_REPORTS_BANNER_MUTATION_KEY =
  'DOWNLOAD_REPORTS_BANNER_MUTATION';

async function exportExcel(params: ReportsBannerDto) {
  return serviceApi.get<Blob>('/Report/DailyRegister-Export', {
    params,
    responseType: 'blob',
  });
}

export function useDownloadReportsBanner(
  onSuccess?: (
    data: AxiosResponse<Blob, unknown>,
    variables: ReportsBannerDto,
    context: ReportsBannerDto
  ) => unknown,
  onError?: (
    error: Error,
    variables: ReportsBannerDto,
    context: ReportsBannerDto | undefined
  ) => unknown
) {
  return useMutation({
    mutationKey: [DOWNLOAD_REPORTS_BANNER_MUTATION_KEY],
    mutationFn: async (params: ReportsBannerDto) => exportExcel(params),
    onSuccess,
    onError,
  });
}
